// Module
var code = "<div data-ng-if=\"showRequest.request.permissions.indexOf('READ_NEGOTIATIONS') != -1 || srCtrl.auth.isAdmin()\">\n    <ng-include src=\"'components/request/view/tabs/negotiation/show-negotiations.html'\">\n    </ng-include>\n</div>";
// Exports
var _module_exports = code;;
var path = 'components/request/view/tabs/show-negotiation.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;